import * as React from "react";
import { SVGProps } from "react";

export const IconRedirect = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.833 13.833H2.167V2.167H8V.5H2.167C1.242.5.5 1.25.5 2.167v11.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V8h-1.667v5.833zM9.667.5v1.667h2.991l-8.191 8.191 1.175 1.175 8.191-8.191v2.991H15.5V.5H9.667z"
      fill="currentColor"
    />
  </svg>
);
